import { render } from "./DetailsPreference.vue?vue&type=template&id=061b36e3"
import script from "./DetailsPreference.vue?vue&type=script&lang=js"
export * from "./DetailsPreference.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__